import styled from "styled-components";
import { Button } from "antd";

export const StyleButton = styled(Button)`
  width: 100%;
  padding: 0;
  margin: 0;
  &:disabled {
    opacity: 0.7;
  }
  border-radius: 8px;
  color: #fff;
`;
